<template>
  <div class="user-container">
    <div class="user-header">
      <div class="user-name__container">
        <div class="user-name">{{ user.username }}</div>
        <div class="status" :class="{'decline' : user.verification == 2, 'aproved': user.verification == 1}">
          {{
            user.verification == 0
              ? "Waiting for approve"
              : user.verification == 2
              ? "Declined"
              : "Approved"
          }}
        </div>
      </div>
      <div class="btn-container_wrap">
        <div class="btn-container">
          <button class="user-btn" @click="modal = true">contact support</button>
        </div>
        <div class="btn-container" v-if="user.verification == 2">
          <button class="user-btn" @click="update" :disabled="disableUpdateButton">Update and check status</button>
        </div>

      </div>
    </div>
   
    <div class="user-data__container">
       <!-- <div class="info-bcr" v-show="user.verification == 1">

          <div class="info-bcr_text">
            <p class="bold">BCR to TRP exchange</p>
            <p class="light">Enter BCR transaction ID to swap your BCR with TRP coins. You will be able to track your transaction history in TPR wallet app.</p>
          </div>

          <div class="info-bcr__input-area">
            <div class="our-bcr">
              <span class="light">Transaction ID</span>
              <span class="bold">BCR wallet {{bcr}}</span>
            </div>
            <div class="input-transition__wrapper">
              <Input type="text" v-model="transactionId" class="input-transaction" :class="{isError: error}" placeholder="Insert transaction ID from BCR wallet here" >
                <div slot="suffix" class="icon-info" >
                  <Poptip  trigger="click" content="Enter ID of transaction from your BCR account in order to proceed" placement="top-end">
                    <Icon type="ios-help" style="color:#fff; lineHeight:0"/>
                  </Poptip>
                </div>
              </Input>
            </div>
            <div>
              <button class="btn-swap" @click.prevent="sendTransaction">swap</button>
            </div>
          </div>

      </div> -->
      <div class="details-wrap" >
        <div class="user-data__title">Personal details</div>
        <div class="user-data__title" @click="edit" style="cursor:pointer" v-show="user.verification == 2">
          Edit details 
          <Icon 
            type="md-create" 
            size="20"
            /></div>
      </div>
      
      <div class="name-area">
        <div class="name-area_row">
          <div class="name-area_row-item">
            <div>First name</div>
            <div>
              <input class="edit-input" :class='{active_error: errorFirstName, active:!readonly }' type="text" v-model="user.first_name" :readonly=readonly >
              <p style="position:absolute; color:red; fontSize:12px; marginLeft:5px" v-if="errorFirstName">Please fill in the first name</p>
            </div>
          </div>
          <div class="name-area_row-item">
            <div>Last name</div>
            <div>
              <input class="edit-input" :class='{active_error: errorLastName, active:!readonly }' type="text" v-model=user.last_name :readonly=readonly>
              <p style="position:absolute; color:red; fontSize:12px; marginLeft:5px" v-if="errorLastName">Please fill in the last name</p>  
            </div>
          </div>
        </div>
        <div class="name-area_row">
          <div class="name-area_row-item">
            <div>Email</div>
            <div>
              <input class="edit-input" :class='{active_error: errorEmail, active:!readonly }' type="text" v-model=user.email :readonly=readonly >
              <p style="position:absolute; color:red; fontSize:12px; marginLeft:5px" v-if="errorEmail">{{!errorEmailValid ? "Please fill in the email" : "Please input correct email"}}</p>
            </div>
          </div>
           <div class="name-area_row-item">
            <div>Mobile phone</div>
            <div>
              <input class="edit-input" :class='{active_error: errorPhone, active:!readonly }' type="text" v-model=user.phone :readonly=readonly >
              <p style="position:absolute; color:red; fontSize:12px; marginLeft:5px" v-if="errorPhone">Please fill in the phone</p>
            </div>
          </div>
        </div>
       
        <div class="name-area_row">
          <div class="name-area_row-item">
            <div>BCR account address</div>
            <div>
              <input class="edit-input"  type="text" v-model=user.bcr_address readonly>
            </div>
          </div>
          <div class="name-area_row-item">
            <div>TPR account address</div>
            <div>
              <input class="edit-input" :class='{active:!readonly}' type="text" v-model=user.tpr_address :readonly=readonly>
            </div>
          </div>
        </div>
         <div class="name-area_row">
          <div class="name-area_row-item">
            <div>Requested TPR balance</div>
            <div>
              <input class="edit-input" :class='{active_error: errorBalance, active:!readonly }' type="text" v-model=user.bcr_request_balance :readonly=readonly >
              <p style="position:absolute; color:red; fontSize:12px; marginLeft:5px" v-if="errorPhone">Please fill in the bcr balance</p>
            </div>
          </div>
        </div>
      </div>
      <div class="link-area">
          <p style="margin-bottom:15px"><strong>Identity verification</strong> </p>
        <div class="link-area_block">

          <div class="link-area_row-bron" >
            <div ><a href="https://portal.bronid.com/idform/thepeoplesreserve" target="_blank">Proceed to BronID KYC page to complete identity verification</a></div>
          </div>

          <div class="link-area_row-instruction" >
            <div >
              <Icon type="md-information-circle" size="16" style="margin-right:5px"/>
              <router-link to="/thank" style="color:#0D1F3C">Read instruction</router-link>
            </div>
            
          </div>

        </div>
      </div>
    </div>
     <Modal
        v-model="modal"
        width = 400
        draggable 
        :footer-hide = futerHide
        class-name="vertical-center-modal"
        >
        <Form >
          <p class="modal__title" >Contact Support</p>
          <p class="modal__subtitle">Please fill out the form and we will contact you to assist with your issue as soon as possible.</p>
          <div v-if="sendMessage">
            <Row >
              <Col span="11">
                <FormItem >
                  <Input type="text" v-model="user.first_name" placeholder="First name" readonly></Input>
                </FormItem>            
              </Col>
              <Col span="11" offset="2">
                <FormItem>
                  <Input type="text" v-model="user.last_name" placeholder="Last name" readonly></Input>
                </FormItem>            
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem prop='email'>
                  <Input type="email" v-model="sendEmail" placeholder="Email" ></Input>
                </FormItem>            
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem prop='phone'>
                  <Input type="text" v-model="sendPhone" placeholder="Your phone number" ></Input>
                </FormItem>            
              </Col>
            </Row>
            <Row>
              <FormItem >
                  <Input v-model="supportText" type="textarea" placeholder="Describe your query here" :rows="5"/>
                </FormItem>  
            </Row>
            <button class="btn-send" @click.prevent="submitMessage" :disabled='disable'>send</button>

          </div>
        </Form>  
    </Modal>
  </div>
</template>

<script>
import mapGetters from "vuex";
import moment from 'moment'

import BCR from '../config/bcr'

export default {
  data() {
    return {
      bcr: BCR,
      transactionId:'',
      disable: false,
      sendEmail: "",
      sendPhone: "",
      futerHide: Boolean(true),
      sendMessage: true,
      modal: false,
      userId: "",
      checkStatus: "",
      firstName: "",
      lastName: "",
      email: "",
      mobilePhone: "",
      BCRWallet: "",
      BCRBalance: "",
      TPRWallet: "",
      supportText: "",
      readonly: true,
      fileSize: 10485760,
      formImages: {
        frontSide: "",
        backSide: "",
        imageWithFace: "",
        regDoc: "",
      },
      formImages: {
        frontSide: "",
        backSide: "",
        imageWithFace: "",
        regDoc: ""
      },
      imageError : {
        frontSide: false,
        backSide: false,
        imageWithFace: false,
        regDoc: false
      },
      error: false,
      errorFirstName: false,
      errorLastName: false,
      errorPhone: false,
      errorEmail: false,
      errorEmailValid: false,
      errorBalance: false
     
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    disableUpdateButton() {
    if (this.readonly) {
      if (this.formImages.frontSide || this.formImages.backSide || this.formImages.imageWithFace || this.formImages.regDoc) {
        return false
      }
      return true
    } 
   
  },
  },
  beforeMount() {
    this.getUser();
  },
  
  methods: {
    sendTransaction() {
      const params = {}
      params['BCRtxID'] = this.transactionId
      if (this.transactionId) {
        this.error = false
        this.$store.dispatch('sendTransactionId', params)
        .then(res => {
          this.$Message.success({
            content: 'BCR to TPR coins exchange succeed!',
            duration: 5
          })
        })
        .catch(err => {
          this.$Message.error({
            content : err.response.data['error'],
            duration: 3
          })
        })
      } else {
        this.error = true
      this.$Message.error({
          content: 'Enter BCR transaction ID',
          duration: 5
        })
      }
        
    },
    submitMessage() {
      this.disable = true
      const params = {}
      params['first_name'] = this.user.first_name
      params['last_name'] = this.user.last_name
      params['email'] = this.sendEmail
      params['phone'] = this.sendPhone
      params['message'] = this.supportText
      
       
      if (this.supportText && this.supportText.length >= 1 && this.sendEmail && this.sendPhone) {
        this.$store.dispatch("sendEmailToSupport", params)
        
        .then(res => {
         this.$Message.success({
           content: "Thank you for your query. Once your issue will be processed we will contact you back."
         })
         this.modal = false
         this.supportText = ''
         this.sendPhone = ''
         this.sendEmail
         this.disable = false
        })
        .catch(err => {
          this.$Message.error({
            content : "Somethimg went wrong",
            duration: 3
          })
        })
        
      }
      else {
        this.$Message.error({
          content : "Please, fill in all the fields",
          duration: 3
        })
        this.disable = false
      }
    },
    getUser() {
      this.$store.dispatch("getUser")
      .catch(err => {
        let error = err.response
        if (error.status == 401) {
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      })    
    },
    edit() {
      this.readonly = !this.readonly
    },
    update() {
      if (this.validFirstName() && this.validLastName() && this.validPhone() && this.validEmail() && this.validBalance()) {
         this.$store.commit('setGlobalLoading', true)
        let formData = new FormData()
        formData.append('first_name', this.user.first_name);
        formData.append('last_name', this.user.last_name);
        formData.append('email', this.user.email);
        formData.append('phone', this.user.phone);
        formData.append('tpr_address', this.user.tpr_address);
        formData.append('bcr_balance', this.user.bcr_request_balance);
        formData.append('front', this.formImages.frontSide);
        formData.append('back', this.formImages.backSide);
        formData.append('self', this.formImages.imageWithFace);
        formData.append('doc', this.formImages.regDoc);
       
        this.$store.dispatch("updateUser", {form:formData})
          .then(() => {
            location.reload();
            this.$Message.success({
              content: 'Your personal data has been updated successfully',
              duration: 3
            })
             this.readonly = true
              this.$store.commit('setGlobalLoading', false)
          })
            .catch(err => {
               this.$store.commit('setGlobalLoading', false)
              this.$Message.error({
                content: err.response.data.error,
                duration: 3
              })
            })
            
      } else {
        this.$Message.error({
          content: "Please fill in the field correctly",
          duration: 5
        })
      }
        
    },
    validFirstName() {
      if (this.user.first_name == '' && this.user.first_name.length >=20) {
        this.errorFirstName = true
        return false
      }
      return true
    },
    validLastName() {
      if (this.user.last_name == '' && this.user.last_name.length >=20) {
        this.errorLastName = true
        return false
      }
      return true
    },
    validPhone() {
      if (this.user.phone == '') {
        this.errorPhone = true
        return false
      }
      
      return true
    },
    validBalance() {
      const reg = /^(\d+\.?\d*|\.\d+)$/
      let valid = reg.test(this.user.bcr_request_balance)
      if (!valid) {
         this.errorBalance = true
         return false
      }
      if (this.user.bcr_request_balance  && !valid) {
        this.errorBalance = true
        return false
      }
      
      return true
    },
    validEmail() {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let valid = reg.test(this.user.email)
      if (!valid) {
        this.errorEmailValid = true
        this.errorEmail = true
        return false
      }
      if (this.user.email == '' && !valid) {
        this.errorEmail = true
        return false
      }
      return true
    },
    checkFileSize(event) {
      return event.target.files[0].size <= this.fileSize ? true : false
    },
    checkFileFormat(event) {
      return (event.target.files[0].type == "image/png" || event.target.files[0].type == "image/jpg" || event.target.files[0].type == "image/jpeg") ? true : false
    },
    onFileSelected(event, file) {
      if(this.checkFileSize(event)) {
        this.formImages[file] = event.target.files[0]      
      } else {
       this.$Message.error({
          content: 'The maximum image size is 10 Mb',
          duration: 3
        })
        this.formImages[file] = ''
        this.imageError[file] = true
        return
      }

      if (this.checkFileFormat(event)) {
        this.formImages[file] = event.target.files[0];
        this.imageError[file] = false
      } else {
        this.$Message.error({
          content: "Wrong data format, select png, jpg, jpeg",
          duration: 3,
        });
        this.formImages[file] = ''
        this.imageError[file] = true
        return
      }
    },
  },
};
</script>
<style >
.ivu-input {
  padding: 23px 7px;
}
.bold {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: bold;
}
.light {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  color: #757575;
}
.isError {
  border: 2px solid red;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .user-header {
    flex-direction: column;
    .btn-container_wrap {
      justify-content: flex-start;
      button {
        font-size: 12px !important;
      }
    }
  }
  .name-area {
    flex-direction: column;
    .name-area_row {
      flex-direction: column;
      margin-bottom: 0 !important;
      .name-area_row-item {
        width: 100% !important;
        margin-bottom: 15px;
      }
    }
  }
  .user-file__container {

    .buttonFile {
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 450px) {
  .user-header {
    flex-direction: column;
    .btn-container_wrap {
      flex-wrap: wrap;
      justify-content: center;
      .btn-container {
        width: 100% !important;
        padding-top: 0 !important;
      }
      button {
        width: 100% !important;
        font-size: 12px !important;
      }
    }
  }
  .details-wrap {
    .user-data__title {
      font-size: 14px !important;
      i {
        font-size: 16px !important;
      }
    }
  }
  .name-area {
    flex-direction: column;
    .name-area_row {
      flex-direction: column;
      margin-bottom: 0 !important;
      .name-area_row-item {
        flex-direction: column;
        width: 100% !important;
        margin-bottom: 15px;
        div {
          width: 100%  !important;
        }
      }
    }
  }
  .user-file__container {

    .buttonFile {
      flex-direction: column;
      align-items: flex-start !important;
      width: 100% !important;
      span {
        margin-bottom: 10px;
      }
    }
  }
}

.user-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 968px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0.1px 0.3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.2);
  padding: 24px 0;
  margin-bottom: 10px;
  
  .user-header {
    width: 100%;
    border-bottom: 1px solid #cbcdff;
    display: flex;
    justify-content: space-between;
    .user-name__container {
      padding: 20px;
      .user-name {
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 28px;
        color: rgba(0, 0, 0, 0.87);
        margin-bottom: 16px;
        
      }
      .status {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        color: #d99a00;
      }
      .decline {
        color: red;
      }
      .aproved {
        color: green;
      }
      
    }
    .btn-container_wrap {
      display: flex;
      .btn-container {
        padding: 20px;
        .user-btn {
          padding: 12px 28px;
          background: #ffe709;
          border-radius: 4px;
          border: none;
          outline: none;
          text-transform: uppercase;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .user-data__container {
    width: 100%;
    display: flex;
    flex-direction: column;
    // border-bottom: 1px solid #cbcdff;
    .details-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.87);
      
    }
    .name-area {
      display: flex;
      flex-direction: column;
      padding: 20px;
      border-bottom: 1px solid #cbcdff;
      .name-area_row {
        display: flex;
        width: 100%;
        margin-bottom: 35px;
       

        .name-area_row-item {
          display: flex;
          align-items: center;
          width: 50%;
           &:nth-child(1) {
            margin-right: 10px;
          }
          div {
            width: 50%;
            input {
              width: 100%;
            }
          }
         
        }
        
      }
      table {
        table-layout: fixed;
        width: 100%;
        text-align: left;
        th:nth-child(odd) {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #757575;
        }
        th:nth-child(even) {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #0d1f3c;
        }
      }
      .wallet {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-basis: 50%;
        &:nth-child(1) {
          margin-right: 10px;
        }
        .wallet_input-wrap {
          width: 200px;
          margin-right: 25px;
          input {
            width: 100%;
          }
        }
      }
    }
    .link-area {
      display: flex;
      flex-direction: column;
      padding: 20px;
      .link-area_block {
        display: flex;
        justify-content: space-between;
      }
      &_row-bron  {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
      }
      &_row-instruction {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        letter-spacing: 0.01em;
        text-transform: uppercase;
        color: #0D1F3C;
      }
      
    }
    .block-details {
      padding: 20px;
      display: flex;
      &__item-title {
        width: 25%;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #757575;
      }
      &__item-data {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #0d1f3c;
        input {
          width: 225px;
        }
      }
    }
    .info-bcr {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #CBCDFF;
      padding: 20px;
      .info-bcr_text {
        margin-bottom: 15px;
      }

      .info-bcr__input-area {
        display: flex;
        align-items: center;
        .our-bcr {
          display: flex;
          flex-direction: column;
          margin-right: 20px;
        }
      }
      .input-transition__wrapper {
        position: relative;
        flex: 1 1 auto;
        margin-right: 10px;
        .input-transaction {
          
          
          .icon-info {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: black;
            top: 15px;
            border-radius: 50px;
            
          }

        }

      }
      .btn-swap {
        padding: 12px;
        background-color: #FFE709;
        border: none;
        border-radius: 5px;
        outline: none;
        cursor: pointer;
        text-transform: uppercase;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
      }
      
    }
  }
  .user-file__container {
    display: flex;
    width: 100%;
    padding: 20px;
    form {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .buttonFile {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        width: 45%;

        &_fileInput {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
        &_lable {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.01em;
          color: black;
          padding: 10px 20px;
          background: #ffe709;
          border-radius: 4px;
          display: inline-block;
          cursor: pointer;
          text-transform: uppercase;
        }
        .uploaded {
          color: #03a900;
        }
        .image_error {
          color: red;      
        }
      }
    }
  }
}
 .edit-input {
        padding: 5px;
        border-radius: 4px;
        border: none;
        text-overflow: ellipsis;
      }
      
      .active {
        border: 1px solid rgb(189, 153, 153);
        &_error {
          border: 2px solid rgb(255, 0, 0);
        }
      }
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal{
    top: 0;
  }
}
.modal__title {
  padding-top: 40px;
  display: flex;
  justify-content: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
}
.modal__subtitle {
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 16px;
}
.btn-send {
  width: 100%;
  background: #FFE709;
  border-radius: 4px;
  padding: 16px;
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  border: none;
}

</style>